import { observer } from "mobx-react";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import NeedHelpCard from "./components/need-help-card/need-help-card";
import { useState, useEffect, useMemo } from "react";
import currentPortalStore from "../../stores/current-portal-store";
import useDashboardTranslation from "../../dashboard-translation/hooks/dashboard-translation-hook";
import RMACountersCard from "./components/rma-counters-card/rma-counters-card";
import ListLayout from "../../components/layouts/list-layout/list-layout";
import ReturnsPortalPreviewModeCard from "./components/returns-portal-preview-mode-card/returns-portal-preview-mode-card";
import dashboardStore from "./stores/dashboard-store";
import { Note, NOTE_TYPE } from "../../components/note/note";
import MissingScopeModal from "./components/missing-scopes-modal/missing-scope-modal";
import MissingTranslationsModal from "./components/missing-translations-modal/missing-translations-modal";
import TranslationsStatusStore from "../../stores/translations-status-store";

const HomePage: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const [ isMissingPortalTranslationsModalOpen, setIsMissingPortalTranslationsModalOpen ] = useState(false);
    const translationsStatusStore = useMemo(() => new TranslationsStatusStore(), []);

    useEffect(() => {
        currentPortalStore.load();
        // Explanation:
        //   no async/await as HP can be rendered while translations status is loading
        translationsStatusStore.load();
        dashboardStore.load();
        dashboardStore.loadNotVerifiedOwnerData();
    }, []);

    useEffect(() => {
        setIsMissingPortalTranslationsModalOpen(translationsStatusStore.hasMissingTranslations);
    }, [translationsStatusStore.hasMissingTranslations]);
    
    const isMerchantOnboarded = !!currentPortalStore.setting?.isMerchantOnboarded;
	const missingAccessScopes = currentPortalStore.currentPortal?.missingAccessScopes;

    return (
        <BasePageLayout
            title={getTranslation('TITLE', 'dashboard-home')}
        >
            <ListLayout>
                { dashboardStore.notVerifiedOwnerMessage &&
                    <Note type={NOTE_TYPE.WARNING} body={
                        <span dangerouslySetInnerHTML={{ __html: dashboardStore.notVerifiedOwnerMessage ?? '' }} />
                    } />
                }
                
                {isMerchantOnboarded ? (
                    <>
                        <RMACountersCard />
                        <ReturnsPortalPreviewModeCard />
                        <NeedHelpCard />
	                    {missingAccessScopes && (
							<>
								{missingAccessScopes.map((missingScope) => (
									<MissingScopeModal key={missingScope} missingScope={missingScope} />
								))}
							</>
	                    )}
                        {isMissingPortalTranslationsModalOpen && (
                            <MissingTranslationsModal setIsOpen={setIsMissingPortalTranslationsModalOpen} />
                        )}
                    </>
                ) : (
                    <>
                        <NeedHelpCard />
                        <RMACountersCard />
                    </>
                )}

            </ListLayout>
        </BasePageLayout>
    );
});

export default HomePage;
